import { render, staticRenderFns } from "./dailyUpdate.vue?vue&type=template&id=5133ce4a&scoped=true&"
import script from "./dailyUpdate.vue?vue&type=script&lang=js&"
export * from "./dailyUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5133ce4a",
  null
  
)

export default component.exports